import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";
import { I18n } from "react-redux-i18n";
import LoadingSpinner from "../../utils/components/LoadingSpinner";
import "../../../styles/components/utils/components/InfoModal.scss";
import "../../../styles/components/insights/history/AddKms.scss";
import info from "../../../styles/images/info.svg";

class AddKms extends Component {
  render() {
    return (
      <Modal
        id="infoModal"
        className="kmsModal"
        show={this.props.show}
        onHide={this.props.onHide}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img src={info} alt="" />
            <span>{this.props.title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="update-kms">
            <p>
              {this.props.evKms
                ? I18n.t("insertKmDialog_topMessageUpdate")
                : I18n.t("insertKmDialog_topMessage")}
            </p>
            {this.props.isLoadingKms ? (
              <LoadingSpinner />
            ) : (
              <input
                type="text"
                name="kms"
                value={
                  this.props.value !== 0
                    ? Math.round(this.props.value)
                    : Math.round(this.props.showKms)
                }
                onChange={this.props.handleInputValueChange}
              />
            )}
            <button onClick={this.props.handleOnUpdateKms}>Enviar</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AddKms;
